var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { getColor, getColors } from '../../utils/Classes';
import { formatNumber } from '../../services/utils/utils';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);
export var ChartPie = function (_a) {
    var titre = _a.titre, datas = _a.datas, _b = _a.half, half = _b === void 0 ? false : _b, _c = _a.displayLegend, displayLegend = _c === void 0 ? true : _c;
    var unite = titre.includes('Nombre') ? '' : '€';
    var palette = getColors();
    var data = {
        labels: datas.map(function (item) { return item.label; }),
        datasets: [
            {
                data: datas.map(function (item) { return item.value; }),
                backgroundColor: datas.map(function (item) { return getColor(palette, item.color); }),
                datalabels: {
                    display: 'auto',
                    formatter: function (value, context) {
                        if (!datas[context.dataIndex] && !datas[context.dataIndex].value) {
                            return;
                        }
                        return formatNumber(datas[context.dataIndex].value, unite);
                    },
                    backgroundColor: getColor(palette, 'white'),
                    borderRadius: 20,
                    borderWidth: 1,
                    padding: 6,
                    borderColor: getColor(palette, 'neutre'),
                    color: getColor(palette, 'neutre'),
                    font: {
                        weight: 'bold',
                    },
                    anchor: 'end',
                    offset: 0,
                },
            },
        ],
    };
    var options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: displayLegend,
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        var _a;
                        var label = (_a = context.label) !== null && _a !== void 0 ? _a : '';
                        if (label) {
                            label += ' : ';
                        }
                        label += formatNumber(context.dataset.data[context.dataIndex], unite);
                        return " ".concat(label);
                    },
                },
            },
            title: {
                padding: 20,
                position: 'top',
                align: 'center',
                display: true,
                text: titre,
            },
        },
    };
    if (half) {
        options.circumference = 180;
        options.rotation = -90;
    }
    return (_jsx("div", __assign({ style: { height: 180 } }, { children: _jsx(Doughnut, { data: data, options: options }) })));
};
//# sourceMappingURL=ChartPie.js.map